import React from 'react';
import { motion } from 'framer-motion';
import { Dna, Brain, Zap, Layers } from 'lucide-react';
const cards = [{
  icon: Dna,
  title: 'Decodificación del ADN del producto',
  desc: 'Analiza tu oferta a nivel profundo para encontrar los ganchos ocultos que tu competencia ignora.'
}, {
  icon: Brain,
  title: '24 ángulos psicológicos probados',
  desc: 'No más adivinanzas. Aplicá frameworks de persuasión basados en dolor, deseo, estatus y FOMO.'
}, {
  icon: Zap,
  title: 'Outputs en minutos',
  desc: 'Generá guiones para VSLs, textos para carruseles, Reels y Meta Ads listos para copiar y pegar.'
}];
export function SolutionSection() {
  return <section className="bg-black py-16 px-4 relative overflow-hidden" data-id="element-123">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-matrix-green/5 to-transparent pointer-events-none" data-id="element-124" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-125">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-126">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-127">
            PromptAdsPro — El Software Estratégico que{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-128">
              Decodifica el Ángulo Correcto
            </span>{' '}
            para Cada Anuncio
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-body text-lg text-gray-300 leading-relaxed" data-id="element-129">
            A diferencia de las herramientas de texto genérico, PromptAdsPro es
            un software que analiza tu producto, selecciona el ángulo
            psicológico adecuado y genera creativos listos para testear.{' '}
            <strong className="text-white" data-id="element-130">
              No es otra app de texto: es ingeniería publicitaria real.
            </strong>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-131">
          {/* Feature Cards */}
          <div className="lg:col-span-5 space-y-6" data-id="element-132">
            {cards.map((card, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.15
          }} className="bg-premium-mid/50 backdrop-blur-md border border-matrix-green/20 p-6 rounded-2xl hover:bg-premium-mid hover:border-matrix-green/40 transition-colors glow-green-sm" data-id="element-133">
                <div className="flex items-start gap-4" data-id="element-134">
                  <div className="bg-matrix-green/15 p-3 rounded-xl" data-id="element-135">
                    <card.icon className="w-6 h-6 text-matrix-green" data-id="element-136" />
                  </div>
                  <div data-id="element-137">
                    <h3 className="font-heading font-bold text-xl text-white mb-2" data-id="element-138">
                      {card.title}
                    </h3>
                    <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-139">
                      {card.desc}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Mechanism Image Replacement */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="lg:col-span-7" data-id="element-140">
            <div className="rounded-3xl border border-matrix-green/30 shadow-2xl relative overflow-hidden glow-green" data-id="element-141">
              <div className="absolute inset-0 bg-matrix-green/10 mix-blend-overlay pointer-events-none" data-id="element-142" />
              <img src="https://i.postimg.cc/5NKdxjhS/3.webp" alt="Sistema de 24 Ángulos Psicológicos" className="w-full h-auto object-cover" data-id="element-143" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}